// API helpers for M7a. Thin wrappers around the existing axios client.
import { apiClient as api } from "./client";

// ---- Preferences ---------------------------------------------------------
export async function getPreferences() {
  const { data } = await api.get("/preferences");
  return data;
}

export async function putPreferences(prefs) {
  const { data } = await api.put("/preferences", prefs);
  return data;
}

export async function patchPreferences(partial) {
  const { data } = await api.patch("/preferences", partial);
  return data;
}

export async function resetPreferences(scope = "all") {
  const { data } = await api.post(`/preferences/reset?vertical=${scope}`);
  return data;
}

export async function getPreferencesMeta() {
  const { data } = await api.get("/preferences/meta");
  return data;
}

// ---- DealFlow Session (2026-07-16) — persistent seen-tracking ------------
export async function resetDealflowSeen(vertical) {
  const { data } = await api.post(
    "/dealflow/seen/reset", vertical ? { vertical } : {},
  );
  return data;
}

export async function getDealflowSeenCount(vertical) {
  const { data } = await api.get("/dealflow/seen/count", {
    params: vertical ? { vertical } : {},
  });
  return data;
}

// ---- DealFlow -----------------------------------------------------------
export async function getDealflow({
  vertical,
  cursor,
  limit = 24,
  country,
  include_unchecked = true,
  include_dead = false,
  force_no_prefs = false,
  transaction_type,
  quality_mode,
}) {
  const params = { limit };
  if (cursor) params.cursor = cursor;
  if (country) params.country = country;
  if (include_unchecked === false) params.include_unchecked = false;
  if (include_dead) params.include_dead = true;
  if (force_no_prefs) params.force_no_prefs = true;
  if (transaction_type) params.transaction_type = transaction_type;
  if (quality_mode) params.quality_mode = quality_mode;
  const { data } = await api.get(`/dealflow/${vertical}`, { params });
  return data;
}

export async function getDealflowDebug({ vertical, sample_size = 5, country }) {
  const params = { sample_size };
  if (country) params.country = country;
  const { data } = await api.get(`/dealflow/${vertical}/debug`, { params });
  return data;
}

// ---- Top Deals ----------------------------------------------------------
export async function getTopDeals({ vertical = "all", limit = 5 } = {}) {
  const { data } = await api.get("/top-deals", {
    params: { vertical, limit },
  });
  return data;
}

// ---- Listings -----------------------------------------------------------
export async function getListing(ulid) {
  const { data } = await api.get(`/listings/${ulid}`);
  return data;
}

// V4.18 — Explainable Market Signal: exact comparables behind the badge.
export async function getComparables(ulid) {
  const { data } = await api.get(`/listings/${ulid}/comparables`);
  return data;
}

// Klagenfurt P0 2026-08 (Review Point 2) — server-built deal_comparables
// widget: purchase + rental + excluded comps, strictly separated per deal.
export async function getDealComparables(ulid, lang = "de") {
  const { data } = await api.get(`/listings/${ulid}/deal-comparables`, {
    params: { lang },
  });
  return data;
}

// ---- Favorites ----------------------------------------------------------
export async function addFavorite(listingUlid) {
  const { data } = await api.post("/favorites", { listing_ulid: listingUlid });
  return data;
}

export async function removeFavorite(listingUlid) {
  await api.delete(`/favorites/${listingUlid}`);
}

export async function listFavorites({ cursor, limit = 24 } = {}) {
  const params = { limit };
  if (cursor) params.cursor = cursor;
  const { data } = await api.get("/favorites", { params });
  return data;
}

// ---- Helpers ------------------------------------------------------------
/** Convert the route token `immo` <-> the canonical preference value `real_estate`. */
export function verticalToPrefValue(vertical) {
  return vertical === "immo" ? "real_estate" : "auto";
}

export function prefValueToVertical(prefValue) {
  return prefValue === "real_estate" ? "immo" : "auto";
}
